import { useEffect } from 'react';

import { useSyncThisDevice } from './useTurnOnThisDevice';

export const usePushDeviceSync = (): void => {
  const { mutate: sync } = useSyncThisDevice();
  useEffect(() => {
    sync();
  }, [sync]);
};
